export enum OwnershipValueType {
  All = "All" as any,
  None = "None" as any,
  Custom = "Custom" as any,
}
